export const activityTypes = [
    'miscActivity',
    'entertainmentActivity',
    'educationalActivity',
    'gameActivity',
    'physicalActivity',
]
